import { store } from "@betacrew/jars-flux";
import { componentKey, setDownloadAllPDFModal, setDownloadMultiplePDFModal, setFederealResubmitGridData, setLoadingState, setMergeFormsCheckbox, setPaginationState, setReferenceNumberList, setResubmitSuccessModal, setSelectedReferenceNumber } from "./FederalResubmitSlice";
import { all, put, takeLatest } from "redux-saga/effects";
import { PAGE_STATE } from "../../../constants/constants";
import { addNotifications } from "../../../toaster/ToasterPortalSlice";
import ResubmitDataService from "../../../../../services/ResubmitDataService";
import General from "../../../../../libs/utility/General";
import ManageFormsService from "../../../../../services/ManageFormsService";
import { TOASTER_VARIANT } from "../../../../components/toast/constants";
import { IRS_FEDERAL_RESUBMIT_LOADING_STATES } from "../constant";

export const { getFederalResubmitReferenceList, getFederalResubmitGridData, federalResubmitFormsExportToExcel, federalResubmitFormsExportToExcelForAll, federalResubmitViewPDF, federalResubmitForm, federalResubmitDownloadAllPDF, federalResubmitDownloadMultiplePDF } = {

    getFederalResubmitReferenceList: (payload) => {
        return {
            type: "FEDERAL_RESUBMIT/GET_REFERENCE_LIST",
            payload
        }
    },

    getFederalResubmitGridData: (payload) => {
        return {
            type: "FEDERAL_RESUBMIT/GET_GRID_DATA",
            payload
        }
    },

    federalResubmitFormsExportToExcel: (payload) => {
        return {
            type: "FEDERAL_RESUBMIT/EXPORT_TO_EXCEL",
            payload
        }
    },

    federalResubmitFormsExportToExcelForAll: (payload) => {
        return {
            type: "FEDERAL_RESUBMIT/EXPORT_TO_EXCEL_FOR_ALL",
            payload
        }
    },

    federalResubmitViewPDF: (payload) => {
        return {
            type: "FEDERAL_RESUBMIT/VIEW_PDF",
            payload
        }
    },

    federalResubmitForm: (payload) => {
        return {
            type: "FEDERAL_RESUBMIT/RESUBMIT_FORM",
            payload
        }
    },

    federalResubmitDownloadAllPDF: (payload) => {
        return {
            type: "FEDERAL_RESUBMIT/DOWNLOAD_ALL_PDF",
            payload
        }
    },

    federalResubmitDownloadMultiplePDF: (payload) => {
        return {
            type: "FEDERAL_RESUBMIT/DOWNLOAD_MULTIPLE_PDF",
            payload
        }
    },

}

function* getFederalResubmitReferenceListAsync(action) {
    try {
        yield put(setLoadingState({ state: IRS_FEDERAL_RESUBMIT_LOADING_STATES.FETCHING_REFERENCES_LOADING }));

        const { referenceId } = action?.payload;

        const response = yield ResubmitDataService.getFederalResubmitReferenceList();
        const { Message, Status, Data } = response?.data || {};

        if (Status) {
            const referenceData = Data.map(r => { return { ...r, label: `${r.ReferenceIDLabel ?? r.ReferenceID}`, value: `${r.ReferenceID}` } })

            if (referenceId) {
                const ref = referenceData.find(r => r?.label == referenceId);

                if (ref) {
                    yield put(setSelectedReferenceNumber(ref));
                }
            }

            yield put(setReferenceNumberList(referenceData))

        } else {
            yield put(addNotifications({ heading: "Failed to fetch the reference list", message: Message }));
        }

    } catch (error) {
        console.log(error);
        yield put(addNotifications({ heading: "Failed to fetch the reference list", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: IRS_FEDERAL_RESUBMIT_LOADING_STATES.FETCHING_REFERENCES_READY }))
    }
}

function* getFederalResubmitGridDataAsync(action) {
    try {
        yield put(setLoadingState({ state: IRS_FEDERAL_RESUBMIT_LOADING_STATES.GRID_LOADING }));

        const { paginationState, referenceId } = action?.payload;

        const params = {
            PageSize: paginationState?.PageSize || 10,
            PageNumber: paginationState?.PageNumber || 1,
            referenceId: referenceId,
            FilterText: "",
            IdNumber: "",
            IsDesc: false
        };

        const response = yield ResubmitDataService.getFederalResubmitGridData(params);
        const { Message, Status, Data } = response?.data || {};

        if (Status) {
            yield put(setFederealResubmitGridData(General.extractDataFromResponseData(response.data)));
            yield put(setPaginationState({ ...paginationState, total: General.extractPaginationTotalFromResponse(response.data) }))
        } else {
            yield put(setFederealResubmitGridData([]));
            yield put(setPaginationState({ ...paginationState, total: 0 }))
            yield put(addNotifications({ heading: "Failed to fetch the grid data", message: Message }));
        }

    } catch (error) {
        console.log(error);
        yield put(addNotifications({ heading: "Failed to fetch the grid data", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: IRS_FEDERAL_RESUBMIT_LOADING_STATES.GRID_READY }))
    }
}

function* federalResubmitFormsExportToExcelAsync(action) {
    try {
        yield put(setLoadingState({ state: IRS_FEDERAL_RESUBMIT_LOADING_STATES.EXPORT_EXCEL_LOADING }));
        const { referenceId } = action.payload;

        const params = { referenceId };
        const response = yield ResubmitDataService.federalResubmitFormsExportToExcel(params);
        const { Message, Status, Data } = response?.data;

        if (Status) {
            General.downloadFileFromBase64(Data.Base64, Data.Name);
        } else {
            yield put(addNotifications({ heading: "Failed to export the sheet", message: Message }));
        }

    } catch (error) {
        console.log(error);
        yield put(addNotifications({ heading: "Failed to export the sheet", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: IRS_FEDERAL_RESUBMIT_LOADING_STATES.EXPORT_EXCEL_READY }))
    }
}

function* federalResubmitFormsExportToExcelForAllAsync(action) {
    try {
        yield put(setLoadingState({ state: IRS_FEDERAL_RESUBMIT_LOADING_STATES.EXPORT_EXCEL_FOR_ALL_LOADING }));
        const { referenceId } = action.payload;

        const params = { referenceId };
        const response = yield ResubmitDataService.federalResubmitFormsExportToExcelForAll(params);
        const { Message, Status, Data } = response?.data;

        if (Status) {
            General.downloadFileFromBase64(Data.Base64, Data.Name);
        } else {
            yield put(addNotifications({ heading: "Failed to export the sheet", message: Message }));
        }

    } catch (error) {
        console.log(error);
        yield put(addNotifications({ heading: "Failed to export the sheet", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: IRS_FEDERAL_RESUBMIT_LOADING_STATES.EXPORT_EXCEL_FOR_ALL_READY }))
    }
}

function* federalResubmitViewPDFAsync(action) {
    try {
        yield put(setLoadingState({ state: IRS_FEDERAL_RESUBMIT_LOADING_STATES.GRID_LOADING }));
        const { referenceId, formRecordId } = action.payload;

        const params = { referenceId, formRecordId };
        const response = yield ResubmitDataService.federalResubmitViewPDF(params);
        const { Message, Status, Data } = response?.data;

        if (Status) {
            General.openBase64FileInNewTab(Data.Base64, Data.Name);
        } else {
            yield put(addNotifications({ heading: "Failed to open the PDF", message: Message }));
        }

    } catch (error) {
        console.log(error);
        yield put(addNotifications({ heading: "Failed to open the PDF", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: IRS_FEDERAL_RESUBMIT_LOADING_STATES.GRID_READY }))
    }
}

function* federalResubmitFormAsync(action) {
    try {
        yield put(setLoadingState({ state: IRS_FEDERAL_RESUBMIT_LOADING_STATES.GRID_LOADING }));
        const { referenceId, FormIDs } = action.payload;

        const response = yield ResubmitDataService.resubmitToIRS({referenceId, FormIDs});
        const { Message, Status, Data } = response?.data;

        if (Status) {
            yield put(setResubmitSuccessModal(true));
        } else {
            yield put(addNotifications({ heading: "Failed to open the PDF", message: Message }));
        }

    } catch (error) {
        console.log(error);
        yield put(addNotifications({ heading: "Failed to resubmit the form", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: IRS_FEDERAL_RESUBMIT_LOADING_STATES.GRID_READY }))
    }
}

function* federalResubmitDownloadAllPDFAsync(action) {
    try {
        yield put(setLoadingState({ state: IRS_FEDERAL_RESUBMIT_LOADING_STATES.DOWNLOAD_ALL_PDF_LOADING }))

        const { payerId, payerName, referenceNo, formId, mergeCopies } = action.payload

        const params = {
            formIds: "",
            payerName: "",
            payerId,
            referenceNo,
            pdfCopy: "all",
            maskTin: false,
            mergeCopies
        }

        const response = yield ManageFormsService.downloadFedPDFsByReference(params)

        const { Message, Status, Data } = response?.data;
        if (Status) {
            if (Data?.Base64) {
                General.downloadFileFromBase64(Data?.Base64, Data?.Name)
            }
            yield put(addNotifications({ heading: "Your request has been processed", message: Message, variant: TOASTER_VARIANT.SUCCESS }));
            yield put(setMergeFormsCheckbox(false));
        } else {
            yield put(addNotifications({ heading: "Failed to download pdf", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to download pdf", message: error?.response?.data?.Message }));
        yield put(setDownloadAllPDFModal(false))
    } finally {
        yield put(setLoadingState({ state: IRS_FEDERAL_RESUBMIT_LOADING_STATES.DOWNLOAD_ALL_PDF_READY }))
    }
}

function* federalResubmitDownloadMultiplePDFAsync(action) {
    try {
        yield put(setLoadingState({ state: IRS_FEDERAL_RESUBMIT_LOADING_STATES.DOWNLOAD_MULTIPLE_PDF_LOADING }))

        const { payerId, formName, payerName, referenceNo, taxYear, pdfCopy, maskTin, FormIds, mergeCopies } = action.payload

        const params = {
            formIds: FormIds,
            payerName,
            payerId,
            referenceNo,
            pdfCopy: "all",
            maskTin: false,
            formName,
            taxYear,
            sourcePage: "Resubmit",
            isCorrected: false,
            mergeCopies: mergeCopies || false
        }

        const response = yield ManageFormsService.downLoadFedMultiplePDFs(params)

        const { Message, Status, Data } = response?.data;

        if (Status) {
            if (Data?.Base64) {
                General.downloadFileFromBase64(Data?.Base64, Data?.Name)
            }
            yield put(addNotifications({ heading: "You request has been proceed", message: Message, variant: TOASTER_VARIANT.SUCCESS }));
            yield put(setMergeFormsCheckbox(false));
        } else {
            yield put(addNotifications({ heading: "Failed to download pdf", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to download pdf", message: error?.response?.data?.Message }));
        yield put(setDownloadMultiplePDFModal(false))
    } finally {
        yield put(setLoadingState({ state: IRS_FEDERAL_RESUBMIT_LOADING_STATES.DOWNLOAD_MULTIPLE_PDF_READY }))
    }
}

function* rootSaga() {
    yield all([
        takeLatest(getFederalResubmitReferenceList().type, getFederalResubmitReferenceListAsync),
        takeLatest(getFederalResubmitGridData().type, getFederalResubmitGridDataAsync),
        takeLatest(federalResubmitFormsExportToExcel().type, federalResubmitFormsExportToExcelAsync),
        takeLatest(federalResubmitFormsExportToExcelForAll().type, federalResubmitFormsExportToExcelForAllAsync),
        takeLatest(federalResubmitViewPDF().type, federalResubmitViewPDFAsync),
        takeLatest(federalResubmitForm().type, federalResubmitFormAsync),
        takeLatest(federalResubmitDownloadAllPDF().type, federalResubmitDownloadAllPDFAsync),
        takeLatest(federalResubmitDownloadMultiplePDF().type, federalResubmitDownloadMultiplePDFAsync)
    ]);
}

store.sagaManager.addSaga(componentKey, rootSaga);